module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter25"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch25"
    }
  }, [_vm._v("Chicken and Spinach Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vibrantly colored spinach gives this beautiful soup its color, while garlic and ginger add to its personality. This soup is terrific as a starter before a meal, but it’s also nice served in mugs for a warm-up after playing in the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 tablespoons vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons freshly grated ginger")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 chicken breast halves, skin and bones removed, cut into ½-inch dice (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("6 cups chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Three 10-ounce packages baby spinach")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Toasted sesame oil for garnishing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chopped green onions for garnishing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("heat the oil in a large skillet or wok over medium-high heat. Add the garlic and ginger and sauté until fragrant, about 30 seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("add the chicken and sauté until the chicken is white on the outside. Add the soy sauce and cook until the soy sauce is almost evaporated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("pour some of the chicken broth into the skillet and transfer the mixture to the insert of a 5- to 7-quart slow cooker, scraping any browned bits from the bottom of the skillet. Add the remaining broth and the spinach to the cooker. Cover and cook on low for 4 to 5 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serve the soup in bowls garnished with a dot of sesame oil and a few pieces of green onion.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v(" chicken savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you would like to use leftover cooked chicken, toss the chicken with the garlic and ginger, add the soy sauce as directed, and proceed with the recipe.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee64ecf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/031-chapter25.vue
// module id = 147
// module chunks = 0